import React from "react";
import { Typography } from "@mui/material";

export default function NotFound({title}) {
  return (
    <Typography align="center" variant="h4" sx={{ my: 2 }}>
      {title ?? "Content Not Found"}
    </Typography>
  );
}
